import { cn } from '@/lib/utils';
import symbolLogo from '@/assets/auto_symbol_logo.png';

interface LoadingSpinnerProps {
    className?: string;
    label?: string;
}

/** Full-screen route loader shown while lazy pages download. */
export const LoadingSpinner = ({ className, label = 'Loading…' }: LoadingSpinnerProps) => {
    return (
        <div className={cn('flex min-h-screen flex-col items-center justify-center gap-5 bg-background p-4', className)} role="status" aria-live="polite">
            <img src={symbolLogo} alt="" className="h-12 w-auto animate-pulse" />
            <div className="h-1 w-32 overflow-hidden rounded-full bg-muted">
                <div className="h-full w-1/3 animate-[loader_1.1s_ease-in-out_infinite] rounded-full bg-primary" />
            </div>
            <span className="sr-only">{label}</span>
            <style>{'@keyframes loader{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}'}</style>
        </div>
    );
};
